import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
    { path: '/404', redirect: '/' }, //重定向
	{
        path: '/',
        name: 'index',
        component: require('./views/index/Customer.vue').default,
    },
    {
        path: '/team',
        name: 'team',
        component: require('./views/index/Team.vue').default,
    },
    {
        path: '/promotion',
        name: 'promotion',
        component: require('./views/index/Promotion.vue').default,
    },    
    {
        path: '/customer',
        name: 'customer',
        component: require('./views/index/Customer.vue').default,
    },
    {
        path: '/setting',
        name: 'setting',
        component: require('./views/index/Setting.vue').default,
    },
	{
        path: '/team/account/add',
        name: 'add-account',
        component: require('./views/team/AddAccount.vue').default,
    },
	{
        path: '/team/account/:id',
        name: 'account-details',
        component: require('./views/team/AccountDetails.vue').default,
    },
    {
        path: '/team/:id',
        name: 'team-details',
        component: require('./views/team/TeamDetails.vue').default,
    },
    {
        path: '/promotion/details/:id',
        name: 'promotion-details',
        component: require('./views/promotion/Details.vue').default,
    },
    {
        path: '/customer/details/:id',
        name: 'customer-details',
        component: require('./views/customer/Details.vue').default,
    },
    {
        path: '/setting/auth/org',
        name: 'auth-org',
        component: require('./views/setting/auth/OrgAuth.vue').default,
    },
    {
        path: '/setting/auth/account',
        name: 'auth-account',
        component: require('./views/setting/auth/AccountAuth.vue').default,
    },
    {
        path: '/setting/wallet/recharge',
        name: 'recharge',
        component: require('./views/setting/wallet/Recharge.vue').default,
    },
    {
        path: '/setting/payview/payview/:orderNo/:cashierTypeId',
        name: 'payview',
        component: require('./views/setting/payview/PayView.vue').default,
    },
    {
        path: '/setting/wallet/record',
        name: 'wallet-record',
        component: require('./views/setting/wallet/Record.vue').default,
    },
    {
        path: '/setting/service',
        name: 'service',
        component: require('./views/setting/service/Service.vue').default,
    },
    {
        path: '/setting/agreement',
        name: 'agreement',
        component: require('./views/setting/agreement/Agreement.vue').default,
    },
    {
        path: '/setting/FAQ',
        name: 'FAQ-index',
        component: require('./views/setting/FAQ/FAQ.vue').default,
    },
    {
        path: '/setting/FAQ/:active/:activeNames',
        name: 'FAQ',
        component: require('./views/setting/FAQ/FAQ.vue').default,
    },
    {
        path: '/setting/account/info',
        name: 'account-info',
        component: require('./views/setting/account/Info.vue').default,
    },
    {
        path: '/subscribe/info',
        name: 'subscribe-info',
        component: require('./views/subscribe/Info.vue').default,
    },
    {
        path: '/subscribe/product',
        name: 'subscribe-product',
        component: require('./views/subscribe/Product.vue').default,
    },
    {
        path: '/promotion/add',
        name: 'promotion-add',
        component: require('./views/promotion/Add.vue').default,
    },
    {
        path: '/customer/add',
        name: 'customer-add',
        component: require('./views/customer/Add.vue').default,
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/setting/customerPoolRule',
        name: 'customer-pool-rule',
        component: require('./views/setting/customerPoolRule/CustomerPoolRule.vue').default,
    },
    {
        path: '/setting/channel/list',
        name: 'channel-list',
        component: require('./views/setting/channel/Channel.vue').default,
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: require('./views/components/Privacy.vue').default,
    },
	{
        path: '/webview/:t/:src',
        name: 'webview',
        component: require('./views/webview/Webview.vue').default,
    },
	
]
const router = new VueRouter({
    base: '/',
    mode: 'hash',
    routes
})
//将clearPending()方法添加到vue路由钩子函数中
router.beforeEach((to, from, next) => {
	if(to.name == 'attestation' && from.name=="home") {
		localStorage.setItem("skip", 1)
	}
	if(to.name == 'attestation' && from.name=="orderInfo") {
		localStorage.setItem("skip", 0)
	}
	next()
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

router.afterEach((route) => {
    let title = route.meta.title
    if (title) {
        document.title = ''
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js